"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanelBody = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Dialog_1 = require("../Dialog");
const helpers_1 = require("../helpers");
const ProgressBar_1 = require("../ProgressBar");
const StackView_1 = require("../StackView");
const View_1 = require("../View");
const ActionsContainer = (0, styled_components_1.default)(StackView_1.StackView) `
    align-self: stretch;
`;
const Progress = (0, styled_components_1.default)(ProgressBar_1.ProgressBar) `
    position: absolute;
    top: -${helpers_1.SIZE_M};
    left: 0;
    right: 0;
`;
const Root = styled_components_1.default.div `
    overflow: auto;
    flex-grow: 1;
    flex-shrink: 1;
    align-self: stretch;

    ${({ growContent }) => growContent
    ? (0, styled_components_1.css) `
                  display: grid;
                  grid-template-rows: 1fr auto;
              `
    : (0, styled_components_1.css) `
                  display: flex;
                  flex-direction: column;
                  flex: 1 1 100%;
                  align-items: stretch;
              `}
`;
const Content = (0, styled_components_1.default)(StackView_1.StackView) `
    overflow: auto;
    flex-shrink: 1;
    padding-bottom: 1px;
    > [data-grid-body-layout='true']:first-child > * > [data-eat-indent='true']:first-child {
        margin-top: -${helpers_1.SIZE_S};
    }
    > *:first-child
        > [data-grid-body-layout='true']:first-child
        > *
        > [data-eat-indent='true']:first-child {
        margin-top: -${helpers_1.SIZE_S};
    }
    ${({ growContent }) => !growContent &&
    (0, styled_components_1.css) `
            width: fit-content;
        `}
`;
exports.SidePanelBody = (0, helpers_1.createUIElement)('SidePanelBody', (_a, ref) => {
    var { className, actions, pending, loading, growContent, content, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "actions", "pending", "loading", "growContent", "content", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const hasProgress = !!pending || !!loading;
    const hasActions = actions && !!actions.length;
    return (react_1.default.createElement(Root, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: `vm-SidePanelBody ${className}`, growContent: growContent, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Content, { spaceHorizontal: View_1.INDENT.m, direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.start, distribution: StackView_1.STACK_DISTRIBUTION.start, growContent: !!growContent }, content || children),
        hasActions && (react_1.default.createElement(ActionsContainer, { root: true, indentHorizontal: View_1.INDENT.m, indentTop: View_1.INDENT.xxl, indentBottom: View_1.INDENT.l, direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.start, distribution: StackView_1.STACK_DISTRIBUTION.start },
            hasProgress && react_1.default.createElement(Progress, null),
            react_1.default.createElement(Dialog_1.DialogActions, { primary: actions, disabled: loading })))));
});
//# sourceMappingURL=SidePanelBody.js.map